{
  "page": {
    "title": "รายงานโปรโมชั่น"
  },
  "column": {
    "sku": "SKU",
    "product_name": "ชื่อสินค้า",
    "marketplace": "มาร์เก็ตเพลส",
    "quota": "โควต้า",
    "used": "ใช้แล้ว",
    "remaining": "คงเหลือ",
    "seller": "ผู้ขาย"
  },
  "action": {
    "export_xlsx": "ส่งออก .xlsx"
  }
}
